import React, { useState, useRef, useEffect } from "react";
import {
  createSubcategory,
  deleteSubcategory,
  getSubcategoryAll,
  updateSubcategory,
  softDeleteSubcategory,
} from "../../Services/SubcategoryService";
import { getSegmentAll } from "../../Services/SegmentService";
import { getCategoryAll } from "../../Services/CategoryService";
import { useForm, Controller } from "react-hook-form";
import Swal from "sweetalert2";
import MTable from "../../Components/MTable/MTable";
import { InputSwitch } from "primereact/inputswitch";
import Overlay from "../../Components/Overlay/Overlay";
import { handlerFormError, uuid } from "../../Utils/Utils";
import { toastError, toastSuccess } from "../../Components/Toasts/Toast";
import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";
import EditButton from "../../Components/Button/EditButton";
import DeleteButton from "../../Components/Button/DeleteButton";

let processingId = -1;

const SubcategoryPage = () => {
  let { userInfo } = useSelector((state) => state.auth);
  const [showAll, setShowAll] = useState(false);
  const mTable = useRef();
  const {
    register,
    handleSubmit,
    reset,
    control,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      id_category: "",
      sub_category_code: "",
      sub_category_name: "",
      init: "",
      is_active: true,
      sort: 0,
    },
  });

  const [state, setState] = useState({
    showForm: false,
    subcategory: {
      id_category: "",
      sub_category_code: "",
      sub_category_name: "",
      init: "",
      is_active: true,
      sort: 0,
    },
    segments: [],
    categories: [],
    processing: false,
    disabled: false,
  });

  useEffect(() => {
    getSegmentAll({ perpage: 100 }, ({ data }) => {
      setState({ ...state, segments: data.data });
    });
  }, []);

  const onActiveChange = (item) => (e) => {
    if (!userInfo.access.master_subcategory.can_update) {
      toastError("You dont have permission for this action");
      return;
    }

    const status = e.target.value ? "Activate" : "Inactive";
    softDeleteSubcategory(item.id, { is_active: e.target.value })
      .then((res) => {
        toastSuccess(`${status} ${item.sub_category_name} Success.`);
        mTable.current.refresh();
      })
      .catch(({ response: { err } }) => {
        toastError(`${status} Failed.`);
      });
  };

  const setChange = (e) => {
    getCategoryAll(
      { perpage: 100, filter: `id_segment:${e.target.value}` },
      ({ data }) => {
        setState({ ...state, categories: data.data });
      }
    );
  };

  const columns = [
    {
      id: uuid(),
      title: "Subcategory Name",
      field: "sub_category_name",
      sortable: true,
    },
    {
      id: uuid(),
      title: "Subcategory Code",
      field: "sub_category_code",
      sortable: true,
    },
    {
      id: uuid(),
      title: "Category Name",
      field: "category_name",
      sortable: true,
    },
    { id: uuid(), title: "Initial", field: "init", sortable: true },
    {
      id: uuid(),
      title: "Active",
      field: "is_active",
      render: (item) => {
        if (item.is_active === true) {
          return <span className="badge badge-success">Active</span>;
        } else {
          return <span className="badge badge-secondary">Inactive</span>;
        }
      },
    },
    {
      id: uuid(),
      title: "",
      sortable: true,
      style: { width: 200 },
      render: (item) => {
        return (
          <div>
            {userInfo.access.master_subcategory.can_update && (
              <EditButton title="Edit" onClick={onEdit(item)} />
            )}
            {userInfo.access.master_subcategory.can_delete && (
              <DeleteButton title="Remove" onClick={onRemove(item)} />
            )}
          </div>
        );
      },
    },
  ];

  const showAllFunc = () => {
    setShowAll(!showAll);
    mTable.current.refresh();
  };

  const propsTable = {
    columns,
    showAllState: showAll,
    showAllFunc,
    getData: (params) => {
      if (showAll === false) {
        if (params.filterAnd) params.filterAnd += "," + `is_active:true`;
        else params.filterAnd = "is_active:true";
      }
      return getSubcategoryAll({ ...params });
    },
    enableFilter: true,
    showAddButton: !userInfo.access.master_subcategory.can_create
      ? false
      : true,
  };

  const removeData = (id) => {
    deleteSubcategory(
      id,
      (res) => {
        if (res.status == 200 || res.status == 201) {
          Swal.fire({
            icon: "success",
            title: "Delete data success",
            text: "Data has been deleted!",
          }).then((res) => {
            mTable.current.refresh();
          });
        }
      },
      ({ response: { data } }) => {
        Swal.fire({
          icon: "error",
          title: "Delete data fail",
          text: data.message,
        });
      }
    );
  };

  const onEdit = (item) => () => {
    if (!userInfo.access.master_subcategory.can_update) {
      return;
    }
    getCategoryAll(
      { perpage: 100, filter: `id_segment:${item.id_segment}` },
      ({ data }) => {
        reset(item);
        setState({
          ...state,
          categories: data.data,
          subcategory: item,
          showForm: true,
          // disabled: true,
        });
      }
    );
  };

  const onRemove = (item) => () => {
    if (!userInfo.access.master_subcategory.can_delete) {
      toastError("You dont have permission for this action");
      return;
    }

    Swal.fire({
      icon: "question",
      title: "Are you sure?",
      text: "Deleted data can not be restored!",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
    }).then(({ isConfirmed }) => {
      if (isConfirmed) {
        removeData(item.id);
      }
    });
  };

  const onAddData = () => {
    if (!userInfo.access.master_subcategory.can_create) {
      return;
    }
    onReset();
    setState({ ...state, showForm: true, disabled: false });
  };

  const startProcessing = () => {
    processingId = setTimeout(() => {
      setState({ ...state, processing: true });
    }, 150);
  };

  const stopProcessing = () => {
    clearTimeout(processingId);
    setState({ ...state, processing: false });
  };

  const onSubmit = (data) => {
    startProcessing();
    const response = subcategory.id
      ? updateSubcategory(subcategory.id, data)
      : createSubcategory(data);
    response
      .then((res) => {
        if (res.status == 200 || res.status == 201) {
          Swal.fire({
            icon: "success",
            title: "Save data success",
            text: "Data has been saved!",
          }).then((r) => {
            mTable.current.refresh();
            subcategory.id ? onCloseForm() : onReset();
          });
        }
      })
      .catch(({ response: { data } }) => {
        handlerFormError(data);
      })
      .finally((_) => stopProcessing());
  };

  const onReset = () => {
    reset({
      id_category: "",
      sub_category_code: "",
      sub_category_name: "",
      init: "",
      is_active: true,
      sort: 0,
    });
    setState({ ...state, subcategory: {} });
  };

  const onCloseForm = () => {
    reset({
      id_category: "",
      sub_category_code: "",
      sub_category_name: "",
      init: "",
      is_active: true,
      sort: 0,
    });
    setState({ ...state, subcategory: {}, showForm: false, disabled: false });
  };

  const { subcategory, processing, showForm, disabled } = state;

  return (
    <div className="content-wrapper">
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h4
                style={{
                  marginTop: "0.5rem",
                  marginLeft: "0.2rem",
                  fontWeight: "400",
                }}
              >
                {showForm ? "Subcategory Form" : "Subcategory Management"}
              </h4>
              <h6
                style={{
                  marginLeft: "0.2rem",
                  fontWeight: "200",
                  letterSpacing: "1.2px",
                }}
              >
                {showForm
                  ? "Add/Edit a product subcategory"
                  : "Database of product subcategories"}
              </h6>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <NavLink to="/home">Home</NavLink>
                </li>
                <li className="breadcrumb-item active">Subategory</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <Overlay display={processing} />

                <form name="form-detail" onSubmit={handleSubmit(onSubmit)}>
                  <div className="card-body">
                    <div
                      className={`${!showForm
                          ? "card__side--front-show"
                          : "card__side--front"
                        }`}
                    >
                      <MTable
                        ref={mTable}
                        {...propsTable}
                        onAddData={onAddData}
                        showIndex={true}
                      />
                    </div>

                    <div
                      className={`${showForm ? "card__side--back-show" : "card__side--back"
                        }`}
                    >
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label>Segment</label>
                            <fieldset disabled={disabled}>
                              <select
                                id="id_segment"
                                className="form-control"
                                {...register("id_segment", {
                                  required: {
                                    value: true,
                                    message: "Segment is required!",
                                  },
                                })}
                                onChange={setChange}
                              >
                                <option value={""}>Select Segment</option>
                                {state.segments.map((seg, i) => (
                                  <option key={`ctg-` + i} value={seg.id}>
                                    {seg.segment_name}
                                  </option>
                                ))}
                              </select>
                              {errors.id_segment && (
                                <span
                                  className="text-danger"
                                  style={{ fontSize: 14 }}
                                >
                                  {errors.id_segment.message}
                                </span>
                              )}
                            </fieldset>
                          </div>
                          <div className="form-group">
                            <label>Category</label>
                            <fieldset disabled={disabled}>
                              <select
                                id="id_category"
                                className="form-control"
                                {...register("id_category", {
                                  required: {
                                    value: true,
                                    message: "Category is required!",
                                  },
                                })}
                              >
                                <option value={""}>Select Category</option>
                                {state.categories.map((cat, i) => (
                                  <option key={`ctg-` + i} value={cat.id}>
                                    {cat.category_name}
                                  </option>
                                ))}
                              </select>
                              {errors.id_category && (
                                <span
                                  className="text-danger"
                                  style={{ fontSize: 14 }}
                                >
                                  {errors.id_category.message}
                                </span>
                              )}
                            </fieldset>
                          </div>
                          <div className="form-group">
                            <label htmlFor="sub_category_code">
                              Subcategory Code
                            </label>
                            <input
                              id="sub_category_code"
                              {...register("sub_category_code", {
                                required: {
                                  value: true,
                                  message: "Subategory code is required!",
                                },
                              })}
                              placeholder="Subategory code"
                              className="form-control"
                            />
                            {errors.sub_category_code && (
                              <span
                                className="text-danger"
                                style={{ fontSize: 14 }}
                              >
                                {errors.sub_category_code.message}
                              </span>
                            )}
                          </div>
                          <div className="form-group">
                            <label htmlFor="sub_category_name">
                              Subcategory Name
                            </label>
                            <input
                              id="sub_category_name"
                              {...register("sub_category_name", {
                                required: {
                                  value: true,
                                  message: "Subategory name is required!",
                                },
                              })}
                              placeholder="Subategory name"
                              className="form-control"
                            />
                            {errors.sub_category_name && (
                              <span
                                className="text-danger"
                                style={{ fontSize: 14 }}
                              >
                                {errors.sub_category_name.message}
                              </span>
                            )}
                          </div>
                          <div className="form-group">
                            <label htmlFor="init">Initial</label>
                            <input
                              id="init"
                              {...register("init", {
                                required: {
                                  value: true,
                                  message: "Segment init is required!",
                                },
                              })}
                              placeholder="Segment initials"
                              className="form-control"
                            />
                            {errors.init && (
                              <span
                                className="text-danger"
                                style={{ fontSize: 14 }}
                              >
                                {errors.init.message}
                              </span>
                            )}
                          </div>
                          {subcategory.id && (
                            <div className="form-group">
                              <label htmlFor="sort">Position Sorting</label>
                              <input
                                id="sort"
                                {...register("sort")}
                                placeholder="Sort"
                                className="form-control"
                                type="number"
                              />
                              {errors.sort && (
                                <span
                                  className="text-danger"
                                  style={{ fontSize: 14 }}
                                >
                                  {errors.sort.message}
                                </span>
                              )}
                            </div>
                          )}
                          <div className="form-group">
                            <label htmlFor="sub-category-name">Active</label>
                            <div>
                              <Controller
                                name="is_active"
                                control={control}
                                render={({ field }) => {
                                  return (
                                    <InputSwitch
                                      {...field}
                                      checked={field.value}
                                    />
                                  );
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {showForm && (
                    <div className="card-footer delay">
                      <div className="row">
                        <div className="col-md-12">
                          <div
                            className="d-flex"
                            style={{ justifyContent: "flex-end" }}
                          >
                            <button
                              type="button"
                              className="btn btn-default mr-3"
                              style={{ width: 100 }}
                              onClick={onCloseForm}
                            >
                              <i className="fa fa-times" /> Close
                            </button>
                            <button
                              type="button"
                              className="btn btn-danger mr-3"
                              style={{ width: 100 }}
                              onClick={onReset}
                            >
                              <i className="fa fa-sync" /> Clear
                            </button>
                            <button
                              type="submit"
                              className="btn btn-dark"
                              style={{ width: 100 }}
                              disabled={
                                control._formValues.id
                                  ? !userInfo.access.master_subcategory
                                    .can_update
                                  : !userInfo.access.master_subcategory
                                    .can_create
                              }
                            >
                              <i className="fa fa-save" /> Save
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default SubcategoryPage;
